import { useContext, useLayoutEffect } from 'react'

import { PageTitleContext } from '../components/PageTitleProvider'

export function usePageTitle (title: string) {
  const { prefix, separator, suffix } = useContext(PageTitleContext)

  useLayoutEffect(() => {
    document.title = [prefix, title, suffix].filter(Boolean).join(separator)
  }, [title, prefix, separator, suffix])
}
